import type { Nullable } from '@iheartjane/types';
import { queryOptions, useQuery } from '@tanstack/react-query';

import { janeApi, safeParseAsync } from '@jane/shared/data-access';
import type { Kiosk } from '@jane/shared/types';

import { zKiosk } from './kiosk.types';

type GetKioskReturnType = {
  kiosk: Kiosk;
};

const getKiosk = async (kioskId: number) => {
  const url = `/kiosks/${kioskId}`;

  const response = await janeApi.get<GetKioskReturnType>(url);

  return await safeParseAsync(zKiosk, response.kiosk, 'getKiosk');
};

export const getKioskQueryOptions = (kioskId: Nullable<number>) =>
  queryOptions({
    queryFn: () => (kioskId ? getKiosk(kioskId) : null),
    queryKey: ['kiosk', kioskId],
  });

interface UseGetKioskArgs {
  initialData: Nullable<Kiosk>;
  kioskId: Nullable<number>;
}
export const useGetKiosk = ({ initialData, kioskId }: UseGetKioskArgs) =>
  useQuery({ ...getKioskQueryOptions(kioskId), initialData });
